import moment from "moment";
import * as React from "react";

import { desktopAPI, isEnabled } from "../epics/electronIntegration";
import { Data } from "../service/Data";
import { reportChange } from "../utils/memo";

export function InputOnChange(
    handler: (value: string, target?: HTMLInputElement | HTMLTextAreaElement) => void
): React.FormEventHandler<HTMLInputElement | HTMLTextAreaElement> {
    return ({ target }) => handler((target as HTMLInputElement).value, target as HTMLInputElement);
}

export function jq(myid: string) {
    return myid.replace(/(:|\.|\[|\]|,|=|@)/g, "-");
}

type aProps = React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
>;

export class ATargetBlank extends React.PureComponent<aProps & { href: string }> {
    private _onClick: React.ReactEventHandler<HTMLAnchorElement> = e => {
        if (isEnabled) {
            e.preventDefault();
            const { href } = this.props;
            desktopAPI.openExternal(href);
        }
    };
    public render() {
        const { href, onClick, children, ...restProps } = this.props;
        const onClickWrapper = (e: React.MouseEvent<HTMLAnchorElement>) => {
            if (onClick) {
                onClick(e);
            } else {
                this._onClick(e);
            }
        };
        return (
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={href}
                onClick={onClickWrapper}
                {...restProps}
            >
                {children}
            </a>
        );
    }
}

export function focusWindow() {
    if (isEnabled) {
        desktopAPI.focusWindow();
    } else {
        window.focus();
    }
}

// http://www.flaticon.com/free-icon/more_149947
export const ThreeDots = React.memo(
    ({ fillColor, height }: { fillColor: string; height: number }) => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 60 60"
                width={height}
                height={height}
            >
                <g>
                    <path
                        d="M30,16c4.411,0,8-3.589,8-8s-3.589-8-8-8s-8,3.589-8,8S25.589,16,30,16z"
                        fill={fillColor}
                    />
                    <path
                        d="M30,44c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,44,30,44z"
                        fill={fillColor}
                    />
                    <path
                        d="M30,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,22,30,22z"
                        fill={fillColor}
                    />
                </g>
            </svg>
        );
    }
);

export function chevron({ fillColor }: { fillColor: string }) {
    return (
        <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g stroke="none" strokeWidth="1" fill={fillColor} fillRule="evenodd">
                <path
                    d="M8,11.8801 L2.999,6.8801 L4.332,5.5471 L8,9.2151 L11.668,5.5471 L13.001,6.8801 L8,11.8801 Z M8,0.0001 C3.582,0.0001 0,3.5821 0,8.0001 C0,12.4181 3.582,16.0001 8,16.0001 C12.418,16.0001 16,12.4181 16,8.0001 C16,3.5821 12.418,0.0001 8,0.0001 L8,0.0001 Z"
                    transform="translate(8.000000, 8.000100) rotate(180.000000) translate(-8.000000, -8.000100) "
                />
            </g>
        </svg>
    );
}

export const arrow = React.memo(() => {
    return (
        <svg
            width="8px"
            height="5px"
            viewBox="0 0 8 5"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g stroke="none" strokeWidth="1" fillRule="evenodd" fill="#687480">
                <polygon points="6.934 0.0000493 4.0005 2.8957965 1.066 0.0000493 0 1.0521511 4.0005 5 8 1.0521511" />
            </g>
        </svg>
    );
});

export const emoji = React.memo(() => {
    return (
        <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill="#687480">
                <g transform="translate(4.500000, 5.000000)">
                    <path d="M1.778,0.889 C1.778,1.38 1.38,1.778 0.889,1.778 C0.398,1.778 0,1.38 0,0.889 C0,0.398 0.398,0 0.889,0 C1.38,0 1.778,0.398 1.778,0.889" />
                    <path d="M6.778,0.889 C6.778,1.38 6.38,1.778 5.888,1.778 C5.398,1.778 5,1.38 5,0.889 C5,0.398 5.398,0 5.888,0 C6.38,0 6.778,0.398 6.778,0.889" />
                </g>
                <path d="M8,12.847 C6.273,12.847 4.653,11.995 3.665,10.571 L4.487,10 C5.288,11.157 6.602,11.847 8,11.847 C9.398,11.847 10.712,11.157 11.513,10 L12.335,10.571 C11.347,11.995 9.727,12.847 8,12.847" />
                <path d="M8,0 C3.582,0 0,3.582 0,8 C0,12.418 3.582,16 8,16 C12.418,16 16,12.418 16,8 C16,3.582 12.418,0 8,0 M8,1 C11.859,1 15,4.14 15,8 C15,11.859 11.859,15 8,15 C4.141,15 1,11.859 1,8 C1,4.14 4.141,1 8,1" />
            </g>
        </svg>
    );
});

export const plusSign = React.memo(() => {
    return (
        <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g stroke="#687480" strokeWidth="2">
                <path d="M0,8 L16,8" />
                <path d="M8,0 L8,16" />
            </g>
        </svg>
    );
});

export function closeSign() {
    return (
        <svg
            width="18px"
            height="18px"
            viewBox="0 0 18 18"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <circle fill="#ffffff" fillRule="evenodd" cx="9" cy="9" r="9" />
                <circle
                    strokeOpacity="0.5"
                    stroke="#354554"
                    strokeWidth="1"
                    cx="9"
                    cy="9"
                    r="8.5"
                />
                <polygon
                    fill="#354554"
                    opacity="0.5"
                    points="12.333445 4.606555 9.000445 7.939555 5.667445 4.606555 4.606445 5.666555 7.939445 8.999555 4.606445 12.333555 5.667445 13.393555 9.000445 10.060555 12.333445 13.393555 13.393445 12.333555 10.060445 8.999555 13.393445 5.666555"
                />
            </g>
        </svg>
    );
}

export class FileIcon extends React.PureComponent<
    {
        width?: number;
        height?: number;
        text: string;
        progress: number;
        inProgress: boolean;
    },
    {}
> {
    private _id = `file-icon-mask-${+new Date()}`;

    public render() {
        const { text, progress, inProgress, width, height } = this.props;
        // this thing makes progress bar to have straight line for progress bar
        const progBarMin = 4;
        const progBarAlmostMax = 30;
        const progBarMax = 32;

        const progBarRectMin = 2;
        const progBarRectMax = 28;

        let progBar = progBarMin + (progBarAlmostMax - progBarMin) * progress;
        let progBarRect = progBarRectMin + (progBar - progBarMin);
        if (progress === 1) {
            progBar = progBarMax;
            progBarRect = progBarRectMax;
        }

        const id = this._id;

        return (
            <svg
                width={width || 46}
                height={height || 60}
                viewBox="0 0 46 60"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g opacity={inProgress ? 0.25 : 1}>
                        <mask id={id} fill="white">
                            <polygon points="0.456005006 0.503011389 0.492257103 59.5271827 45.4878141 59.4874019 45.4878141 16.9389701 29.0358078 0.483450476" />
                        </mask>
                        <g mask={"url(#" + id + ")"}>
                            <rect
                                fill="#ffffff"
                                fillRule="evenodd"
                                x="0.483870968"
                                y="0.483870968"
                                width="45"
                                height="59.0322581"
                                rx="4"
                            />
                            <rect
                                stroke="#354554"
                                strokeWidth="1"
                                x="0.983870968"
                                y="0.983870968"
                                width="44"
                                height="58.0322581"
                                rx="4"
                            />
                        </g>
                        <rect
                            fill="#354554"
                            mask={"url(#" + id + ")"}
                            x="29.0322581"
                            y="-4.83870968"
                            width="21.7741935"
                            height="21.7741935"
                            rx="4"
                        />
                        <text
                            textAnchor="middle"
                            transform="translate(23, 36.6)"
                            width="20"
                            fontFamily=".AppleSystemUIFont"
                            fontSize="12"
                            fontWeight="normal"
                            fill="#354554"
                        >
                            {text}
                        </text>
                    </g>
                    {inProgress && (
                        <g transform="translate(7.000000, 49.000000)">
                            <g>
                                <rect
                                    fill="#7d8a97"
                                    fillRule="evenodd"
                                    x="0"
                                    y="0"
                                    width={progBarMax}
                                    height="4"
                                    rx="2"
                                />
                                <rect
                                    stroke="#687480"
                                    strokeWidth="1"
                                    x="-0.5"
                                    y="-0.5"
                                    width="33"
                                    height="5"
                                    rx="2.5"
                                />
                            </g>
                            <rect fill="#ffffff" x="0" y="0" width={progBar} height="4" rx="2" />
                            <rect fill="#ffffff" x="2" y="0" width={progBarRect} height="4" />
                        </g>
                    )}
                </g>
            </svg>
        );
    }
}

export function nextPage() {
    return (
        <svg
            width="11px"
            height="16px"
            viewBox="0 0 11 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fillRule="evenodd" fill="#FFFFFF">
                <polygon points="2.132 0 0 2.133 5.868 8 0 13.868 2.132 16 10.132 8" />
            </g>
        </svg>
    );
}

export const levelTitle = (level: Data.Level, ing: boolean) => {
    if (level === "ignore") {
        return ing ? "ignoring" : "ignore";
    } else if (level === "watch") {
        return "";
    } else {
        return `${level}${ing ? "ing" : ""}`;
    }
};

export function useTimeoutValue<V>(initialValue: V, timeouValue: V, timeout: number) {
    const [state, setState] = React.useState(initialValue);
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setState(timeouValue);
        }, timeout);
        return () => {
            clearTimeout(timer);
        };
    }, [timeouValue, timeout]);
    return state;
}

export function CurrentTimeWithOffset({
    tzOffset,
    hideDate,
    hideUtcOffset,
}: {
    tzOffset?: number;
    hideDate?: boolean;
    hideUtcOffset?: boolean;
}) {
    const [now, setNow] = React.useState(moment());
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setNow(moment());
        }, (60 - now.seconds()) * 1000);
        return () => {
            clearTimeout(timer);
        };
    }, [now]);

    let nowWithOffset = now;
    if (tzOffset !== undefined) {
        nowWithOffset = now.clone().utcOffset(tzOffset);
    }

    const dayFormat = "D MMM";
    const timeFormat = "h:mm A";
    const tzOffsetFormat = `(UTC${tzOffset !== 0 ? "Z" : ""})`;

    const clockParts = [] as string[];
    if (now.date() !== nowWithOffset.date() && !hideDate) {
        clockParts.push(nowWithOffset.format(dayFormat));
    }
    clockParts.push(nowWithOffset.format(timeFormat));
    if (tzOffset !== undefined && !hideUtcOffset) {
        clockParts.push(nowWithOffset.format(tzOffsetFormat));
    }

    return <>{clockParts.join(" ")}</>;
}

export function sameroomTypeToName(type: string) {
    switch (type) {
        case "chalet":
            return "8x8 Virtual Office";
        case "hipchat":
            return "HipChat";
        case "stride":
            return "Atlassian Stride";
        case "slack":
            return "Slack";
        case "flowdock":
            return "Flowdock";
        case "gitter":
            return "Gitter";
        case "campfire":
            return "Campfire";
        case "google":
            return "Google Hangouts";
        case "skype":
            return "Skype";
        case "fleep":
            return "Fleep";
        case "twitter":
            return "Twitter";
        case "chatter":
            return "Salesforce Chatter";
        case "yammer":
            return "Yammer";
        case "msbot_skype":
            return "Skype";
        case "msbot_msteams":
            return "Microsoft Teams";
        case "grape":
            return "Grape";
        case "xmpp":
            return "Cisco Jabber";
        case "spark":
            return "Cisco Webex Teams";
        case "msbot_telegram":
            return "Telegram";
        case "msbot_groupme":
            return "GroupMe";
        default:
            if (type.startsWith("mattermost_")) {
                return "Mattermost";
            } else if (type.startsWith("rocketchat_")) {
                return "RocketChat";
            } else if (type.startsWith("irc_")) {
                return "IRC";
            }
            return type;
    }
}

export const lazyBundle = (
    module: "RosterSettings" | "CreateForumModal" | "RoomBackSettings" | "Clock" | "AdminPage"
) => React.lazy(async () => ({ default: (await import("./bundleSecondary")).bundle[module] }));

export function ReportChange(props: { suffix?: string; kind?: "render" | "update" } & object) {
    // when using concurent mode consider using `update` instead of `render`
    const { suffix = "", kind = "update" } = props;
    const reporter = React.useRef(reportChange());

    React.useLayoutEffect(() => {
        if (kind === "update") {
            // tslint:disable-next-line:no-console
            console.log("render " + suffix, reporter.current(props));
        }
    });
    if (kind === "render") {
        // tslint:disable-next-line:no-console
        console.log("render " + suffix, reporter.current(props));
    }
    return null;
}
